module.exports = __webpack_public_path__ + "static/media/eye_phone.cb848c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/eye_phone.png
// module id = 89
// module chunks = 0